<template>
  <a-modal
    :title="isCreate ? 'Add Email Recipient' : 'Update Email Recipient'"
    destroyOnClose
    v-model:visible="modalVisible"
    :maskClosable="false"
    :footer="null"
    class="email-recipient-modal"
  >
    <a-form
      :model="form"
      :rules="rules"
      :initial-values="{
        email: initialValue?.email || '',
        recipientType: initialValue?.recipientType || 'standard',
        isOptedOut: initialValue?.isOptedOut || false,
      }"
      @finish="onFinish"
      :labelCol="{ span: 6 }"
      :wrapperCol="{ span: 14 }"
    >
      <a-form-item label="Email" name="email" validateFirst>
        <a-input
          v-model:value="form.email"
          :disabled="!isCreate"
          class="email-recipient-email-input"
        />
      </a-form-item>
      <a-form-item name="recipientType">
        <template #label>
          <a-tooltip>
            <template #title>
              <div>
                <div>
                  <strong>Priority Receiver</strong> - receives the alerts for
                  when solshare is offline for 24hrs and follow up after 7 and
                  14 days.
                </div>
                <div>
                  <strong>Standard Receiver</strong> - receives the alerts
                  delayed by 48 hours to allow the priority receiver to respond.
                </div>
              </div>
            </template>
            Type
            <QuestionCircleOutlined style="margin-left: 4px; color: #999" />
          </a-tooltip>
        </template>
        <a-radio-group v-model:value="form.recipientType">
          <a-radio :value="'priority'">Priority</a-radio>
          <a-radio :value="'standard'">Standard</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="Opt out" name="isOptedOut">
        <a-switch v-model:checked="form.isOptedOut" />
      </a-form-item>
      <a-form-item :wrapperCol="{ span: 14, offset: 6 }">
        <a-button
          block
          htmlType="submit"
          :loading="isSubmitting"
          type="primary"
          class="email-recipient-submit"
        >
          {{ isCreate ? 'Add' : 'Update' }}
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { QuestionCircleOutlined } from '@ant-design/icons-vue';

export default {
  name: 'EmailRecipientModal',
  components: {
    QuestionCircleOutlined,
  },
  props: {
    visible: Boolean,
    isSubmitting: Boolean,
    isCreate: Boolean,
    onSubmit: Function,
    // Duplication check only
    emailRecipients: Array,
    initialValue: Object,
  },

  data() {
    return {
      form: {
        email: '',
        recipientType: 'priority',
        isOptedOut: false,
      },
      rules: {
        email: [
          {
            required: true,
            message: 'Email is required.',
            trigger: 'blur',
          },
          { type: 'email', message: 'email format is incorrect' },
          { validator: this.duplicateCheck },
        ],
      },
    };
  },
  computed: {
    modalVisible: {
      get() {
        return this.visible;
      },
      set(visible) {
        this.$emit('update:visible', visible);
      },
    },
  },
  watch: {
    initialValue: {
      handler(newVal) {
        if (newVal) {
          this.form.email = newVal.email || '';
          this.form.recipientType = newVal.recipientType || 'priority';
          this.form.isOptedOut = newVal.isOptedOut ?? false;
        }
      },
      immediate: true,
    },
    visible(val) {
      if (!val) {
        this.form.email = '';
        this.form.recipientType = 'priority';
        this.form.isOptedOut = false;
      } else if (val && this.initialValue) {
        this.form.email = this.initialValue.email || '';
        this.form.recipientType = this.initialValue.recipientType || 'priority';
        this.form.isOptedOut = this.initialValue.isOptedOut ?? false;
      }
    },
  },
  methods: {
    onFinish(values) {
      const _values = this.isCreate
        ? values
        : Object.assign({}, values, { id: this.initialValue.id });
      this.onSubmit && this.onSubmit(_values);
    },
    duplicateCheck(rule, value) {
      if (
        this.isCreate &&
        this.emailRecipients.some((alertEmail) => alertEmail.email === value)
      ) {
        return Promise.reject('The email already exists');
      }
      return Promise.resolve();
    },
  },
};
</script>

<style scoped></style>
